
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import AccessDenied from '@/components/AccessDenied';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAdmin = false 
}) => {
  const { user, loading, adminLoading, isAdmin } = useAuth();

  // Show loading while auth context is still loading OR admin status is being checked
  if (loading || (requireAdmin && adminLoading)) {
    return (
      <div className="flex items-center justify-center min-h-screen flex-col">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-brand-primary mb-4"></div>
        <p className="text-gray-600">Loading...</p>
      </div>
    );
  }

  // No user found - redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // User is not admin but admin is required - show access denied dialog
  if (requireAdmin && !isAdmin) {
    return <AccessDenied userEmail={user.email || null} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
